import React, { useEffect } from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { NewJoineeAPI } from "../api";
import moment from "moment";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import FormLabel from "@mui/material/FormLabel";
import { selectUser } from "../../redux/modules/userSlice";
import { useSelector } from "react-redux";
import { validateDate } from "@mui/x-date-pickers/internals";
import { useLocation, useParams } from "react-router-dom";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import useDraft from "../../hooks/useDraft";
import { toast } from "react-toastify";
import DraftSavedAt from "../Shared/DraftSavedAt";
import { pickSectionDraftData } from "../../drafts/draftHelpers";

function SectionB({ changeTab, handleButtonClick }) {
  const { user } = useSelector(selectUser);
  const params = useParams();
  const id = params.id ? params.id : "";
  const {
    loadDraft: loadSectionBDraft,
    saveDraft,
    deleteDraft,
    saving: draftSaving,
    lastDraftedAt,
  } = useDraft("newJoinee", "B");
  const { loadDraft: loadSectionADraft } = useDraft("newJoinee", "A");
  const [newJoineeSectionBFlagButton, setNewJoineeSectionBFlagButton] =
    useState("");
  const regexName = /^[a-zA-Z0-9._/&\s]+$/;
  const regexforcity = /^[a-zA-Z\s]+$/;
  const regexPersonDesignation = /^[a-zA-Z-._&\s]+$/;
  const regex = /^[a-zA-Z\s]+$/;
  const regexRenumeration = /^[^e\d]*\d+[^e\d]*$/;

  const initialState = [
    {
      userId: user.isAdmin ? id : user._id,
      employerName: "",
      companyContact: "",
      department: "",
      employeeCode: "",
      designation: "",
      remuneration: "",
      reportedTo: "",
      reportedPersonDesig: "",
      natureOfBusiness: "",
      typeOfEmployment: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      doj: null,
      dol: null,
      reasonForLeaving: "",
      referenceContactPerson1Name: "",
      referenceContactPerson1Contact: "",
      referenceContactPerson2Name: "",
      referenceContactPerson2Contact: "",
      isEdit: true,
    },
  ];

  const expandEmploymentHistoryRows = (items) =>
    items.map((item) => ({ ...item, isEdit: true }));

  const [employmentHistory, setEmploymentHistory] = useState([...initialState]);

  const [fresher, setFresher] = useState(false);
  const [error, setError] = useState({
    employerName: false,
    companyContact: false,
    referenceContactPerson1Name: false,
    referenceContactPerson1Contact: false,
    referenceContactPerson2Name: false,
    referenceContactPerson2Contact: false,
  });

  useEffect(() => {
    let isActive = true;

    (async () => {
      let sectionBDraftItems = null;
      let sectionADraftHasPriorExperience = null;

      if (!user.isAdmin) {
        const loadedSectionADraft = await loadSectionADraft();
        const sectionADraftData =
          loadedSectionADraft && loadedSectionADraft.data
            ? loadedSectionADraft.data
            : null;
        if (
          sectionADraftData &&
          sectionADraftData.user &&
          typeof sectionADraftData.user.isFresher === "boolean"
        ) {
          sectionADraftHasPriorExperience = sectionADraftData.user.isFresher;
        }

        const loadedDraft = await loadSectionBDraft();
        const draftData = loadedDraft && loadedDraft.data ? loadedDraft.data : null;
        sectionBDraftItems =
          draftData &&
          draftData.employmentHistory &&
          Array.isArray(draftData.employmentHistory.employmentHistory)
            ? draftData.employmentHistory.employmentHistory
            : null;
      }

      try {
        const res = await NewJoineeAPI.getEmploymentHistory(
          user.isAdmin ? id : user._id
        );
        if (!isActive) return;

        const hasPriorExperience =
          sectionADraftHasPriorExperience !== null
            ? sectionADraftHasPriorExperience
            : res.sectionAData.isFresher;

        if (hasPriorExperience) {
          if (sectionBDraftItems && sectionBDraftItems.length > 0) {
            setEmploymentHistory(expandEmploymentHistoryRows(sectionBDraftItems));
          } else if (res.data.length > 0) {
            setEmploymentHistory(expandEmploymentHistoryRows(res.data));
          }
          setFresher(false);
        } else {
          setEmploymentHistory([...initialState]);
          setFresher(true);
          if (sectionBDraftItems && sectionBDraftItems.length > 0 && !user.isAdmin) {
            deleteDraft();
          }
        }

        setNewJoineeSectionBFlagButton(
          res ? res.sectionAData.isNewJoineeFormComplete : ""
        );
      } catch (err) {
        console.log(err);
      }
    })();

    return () => {
      isActive = false;
    };
  }, [deleteDraft, id, loadSectionADraft, loadSectionBDraft, user._id, user.isAdmin]);

  const handleSaveDraft = async () => {
    if (user.isAdmin) return;
    const wrapped = pickSectionDraftData("newJoinee", "B", {
      employmentHistory,
    });
    const saved = await saveDraft(wrapped);
    if (saved && saved.skipped) {
      toast.info("Nothing to save as draft");
      return;
    }
    if (saved) toast.success("Draft saved");
    else toast.error("Unable to save draft");
  };

  const [validateerror, setvalidateerror] = useState();

  const sectionBErrorSelector = '[aria-invalid="true"], .Mui-error';

  const isVisibleElement = (element) =>
    element &&
    (element.offsetWidth || element.offsetHeight || element.getClientRects().length);

  const scrollToSectionBError = (selector = sectionBErrorSelector) => {
    setTimeout(() => {
      let candidates = Array.from(document.querySelectorAll(selector));
      let target = candidates.find(isVisibleElement);

      if (!target && selector !== sectionBErrorSelector) {
        candidates = Array.from(document.querySelectorAll(sectionBErrorSelector));
        target = candidates.find(isVisibleElement);
      }

      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
        const focusTarget = target.matches(
          'input, textarea, button, [role="button"], [role="combobox"]',
        )
          ? target
          : target.querySelector(
              'input, textarea, button, [role="button"], [role="combobox"]',
            );
        if (focusTarget && typeof focusTarget.focus === "function") {
          focusTarget.focus({ preventScroll: true });
        }
      }
    }, 0);
  };

  const validatehandler = () => {
    const arr = [
      employmentHistory.map((e) => e.employerName),
      employmentHistory.map((e) => e.companyContact),
      employmentHistory.map((e) => e.department),
      employmentHistory.map((e) => e.employeeCode),
      employmentHistory.map((e) => e.designation),
      employmentHistory.map((e) => e.remuneration),
      employmentHistory.map((e) => e.reportedTo),
      employmentHistory.map((e) => e.reportedPersonDesig),
      employmentHistory.map((e) => e.natureOfBusiness),
      employmentHistory.map((e) => e.typeOfEmployment),
      employmentHistory.map((e) => e.addressLine1),
      employmentHistory.map((e) => e.addressLine2),
      employmentHistory.map((e) => e.city),
      employmentHistory.map((e) => e.state),
      employmentHistory.map((e) => e.doj),
      employmentHistory.map((e) => e.dol),
      employmentHistory.map((e) => e.reasonForLeaving),
      employmentHistory.map((e) => e.referenceContactPerson1Name),
      employmentHistory.map((e) => e.referenceContactPerson1Contact),
      employmentHistory.map((e) => e.referenceContactPerson2Name),
      employmentHistory.map((e) => e.referenceContactPerson2Contact),
    ];
    var arrName = [
      Array.from(employmentHistory, (e, i) => `employerName${i}`),
      Array.from(employmentHistory, (e, i) => `companyContact${i}`),
      Array.from(employmentHistory, (e, i) => `department${i}`),
      Array.from(employmentHistory, (e, i) => `employeeCode${i}`),
      Array.from(employmentHistory, (e, i) => `designation${i}`),
      Array.from(employmentHistory, (e, i) => `remuneration${i}`),
      Array.from(employmentHistory, (e, i) => `reportedTo${i}`),
      Array.from(employmentHistory, (e, i) => `reportedPersonDesig${i}`),
      Array.from(employmentHistory, (e, i) => `natureOfBusiness${i}`),
      Array.from(employmentHistory, (e, i) => `typeOfEmployment${i}`),
      Array.from(employmentHistory, (e, i) => `addressLine1${i}`),
      Array.from(employmentHistory, (e, i) => `addressLine2${i}`),
      Array.from(employmentHistory, (e, i) => `city${i}`),
      Array.from(employmentHistory, (e, i) => `state${i}`),
      Array.from(employmentHistory, (e, i) => `doj${i}`),
      Array.from(employmentHistory, (e, i) => `dol${i}`),
      Array.from(employmentHistory, (e, i) => `reasonForLeaving${i}`),
      Array.from(
        employmentHistory,
        (e, i) => `referenceContactPerson1Name${i}`
      ),
      Array.from(
        employmentHistory,
        (e, i) => `referenceContactPerson1Contact${i}`
      ),
      Array.from(
        employmentHistory,
        (e, i) => `referenceContactPerson2Name${i}`
      ),
      Array.from(
        employmentHistory,
        (e, i) => `referenceContactPerson2Contact${i}`
      ),
    ];
    const keyObj = [];

    for (let i = 0; i < arr.length; i++) {
      let employmentHistory = [];
      for (let j in arr[i]) {
        if (!arr[i][j]) {
          employmentHistory.push({
            name: arrName[i][j],
            status: true,
          });
        } else {
          employmentHistory.push({
            name: arrName[i][j],
            status: false,
          });
        }
      }
      keyObj.push(employmentHistory);
    }
    setvalidateerror(keyObj);
    const arrData = [];
    for (let i in arr) {
      for (let j in arr[i]) {
        arrData.push(arr[i][j]);
      }
    }
    const check = arrData.every((e) => {
      if (Array.isArray(e)) {
        return e.every((x) => x);
      } else {
        return e;
      }
    });
    return check;
  };

  const convertToCamelCase = (input) => {
    if (input === null || input.length === 0) {
      return input;
    }
    const words = input.split(" ");
    const camelCaseWords = words.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });

    return camelCaseWords.join(" ");
  };

  const handleAddHistroy = () => {
    let tempHistory = [...employmentHistory];
    tempHistory.push({
      userId: user.isAdmin ? id : user._id,
      employerName: "",
      companyContact: "",
      department: "",
      employeeCode: "",
      designation: "",
      remuneration: "",
      reportedTo: "",
      reportedPersonDesig: "",
      natureOfBusiness: "",
      typeOfEmployment: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      doj: null,
      dol: null,
      reasonForLeaving: "",
      referenceContactPerson1Name: "",
      referenceContactPerson1Contact: "",
      referenceContactPerson2Name: "",
      referenceContactPerson2Contact: "",
      isEdit: true,
    });
    setEmploymentHistory([...tempHistory]);
  };

  const handleDeleteHistory = (index) => {
    let tempHistory = [...employmentHistory];
    if (tempHistory[index]._id) {
      NewJoineeAPI.deleteEmploymentHistory(tempHistory[index]._id).catch(
        (err) => {
          console.log(err);
        }
      );
    }
    tempHistory.splice(index, 1);
    setEmploymentHistory([...tempHistory]);
  };

  const handleEmpChange = (e, index, field) => {
    const { value } = e.target;
    const camelCaseValue = convertToCamelCase(value);
    let tempHistory = [...employmentHistory];
    tempHistory[index][field] = camelCaseValue;

    let errorDestr = { ...error };
    if (field === "employerName") {
      if (!value.trim()) {
        errorDestr.employerName = true;
      } else {
        errorDestr.employerName = false;
      }
      setError(errorDestr);
    }
    if (regexName.test(e.target.value)) {
      setEmploymentHistory([...tempHistory]);
    }

    if (validateerror) {
      const validateChange = [...validateerror];
      if (field === "employerName" && validateChange[0][index]) {
        validateChange[0][index].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  const handleReasonForLeaving = (e, index, field) => {
    const { value } = e.target;
    let tempHistory = [...employmentHistory];
    tempHistory[index][field] = value;
    setEmploymentHistory([...tempHistory]);

    if (validateerror) {
      const validateChange = [...validateerror];
      if (field === "reasonForLeaving" && validateChange[16][index]) {
        validateChange[16][index].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  const handleAddressChange = (e, index, field) => {
    const { value } = e.target;
    let tempHistory = [...employmentHistory];
    if (field === "addressLine1") {
      tempHistory[index][field] = value;
      setEmploymentHistory([...tempHistory]);
    }
    if (field === "addressLine2") {
      tempHistory[index][field] = value;
      setEmploymentHistory([...tempHistory]);
    }

    if (validateerror) {
      const validateChange = [...validateerror];

      if (field === "addressLine1" && validateChange[10][index]) {
        validateChange[10][index].status = false;
      }
      if (field === "addressLine2" && validateChange[11][index]) {
        validateChange[11][index].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  const handleCityChange = (e, index, field) => {
    const { value } = e.target;
    let tempHistory = [...employmentHistory];
    if (value === "") {
      tempHistory[index][field] = value;
      setEmploymentHistory([...tempHistory]);
    }
    if (regexforcity.test(value)) {
      tempHistory[index][field] = value;
      setEmploymentHistory([...tempHistory]);
    }

    if (validateerror) {
      const validateChange = [...validateerror];

      if (field === "city" && validateChange[12][index]) {
        validateChange[12][index].status = false;
      }
      if (field === "state" && validateChange[13][index]) {
        validateChange[13][index].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  const handleChange = (e, index, field) => {
    const { value } = e.target;
    const camelCaseValue = convertToCamelCase(value);
    let tempHistory = [...employmentHistory];
    tempHistory[index][field] = camelCaseValue;

    setEmploymentHistory([...tempHistory]);

    if (validateerror) {
      const validateChange = [...validateerror];

      if (field === "department" && validateChange[2][index]) {
        validateChange[2][index].status = false;
      }
      if (field === "employeeCode" && validateChange[3][index]) {
        validateChange[3][index].status = false;
      }
      if (field === "designation" && validateChange[4][index]) {
        validateChange[4][index].status = false;
      }
      if (field === "natureOfBusiness" && validateChange[8][index]) {
        validateChange[8][index].status = false;
      }
      if (field === "typeOfEmployment" && validateChange[9][index]) {
        validateChange[9][index].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  const handleRemunerationChange = (e, index, field) => {
    const { value } = e.target;
    let tempHistory = [...employmentHistory];
    tempHistory[index][field] = value;
    if (regexRenumeration.test(value)) {
      setEmploymentHistory([...tempHistory]);
    }

    if (validateerror) {
      const validateChange = [...validateerror];
      if (field === "remuneration" && validateChange[5][index]) {
        validateChange[5][index].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  const handleReportedToChange = (e, index, field) => {
    const { value } = e.target;
    const camelCaseValue = convertToCamelCase(value);
    let tempHistory = [...employmentHistory];

    if (value === "") {
      tempHistory[index][field] = camelCaseValue;
      setEmploymentHistory([...tempHistory]);
    }
    if (regexforcity.test(value)) {
      tempHistory[index][field] = camelCaseValue;
      setEmploymentHistory([...tempHistory]);
    }

    if (validateerror) {
      const validateChange = [...validateerror];
      if (field === "reportedTo" && validateChange[6][index]) {
        validateChange[6][index].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  const handleReportedPersonDesignation = (e, index, field) => {
    const { value } = e.target;
    const camelCaseValue = convertToCamelCase(value);
    let tempHistory = [...employmentHistory];

    if (value === "") {
      tempHistory[index][field] = camelCaseValue;
      setEmploymentHistory([...tempHistory]);
    }
    if (regexPersonDesignation.test(value)) {
      tempHistory[index][field] = camelCaseValue;
      setEmploymentHistory([...tempHistory]);
    }

    if (validateerror) {
      const validateChange = [...validateerror];
      if (field === "reportedPersonDesig" && validateChange[7][index]) {
        validateChange[7][index].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  const handleContactChange = (e, index, field) => {
    const { value } = e.target;

    if (field === "companyContact" && value.length <= 10) {
      let tempHistory = [...employmentHistory];
      tempHistory[index][field] = value;
      setEmploymentHistory([...tempHistory]);

      let errorDestr = { ...error };
      if (value.length !== 10) {
        errorDestr.companyContact = true;
      } else {
        errorDestr.companyContact = false;
      }
      setError(errorDestr);
    }

    if (validateerror) {
      const validateChange = [...validateerror];
      if (validateChange[1][index]) {
        validateChange[1][index].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  const handleReferenceChange = (e, index, field) => {
    const { value } = e.target;
    const camelCaseValue = convertToCamelCase(value);

    if (field === "referenceContactPerson1Name") {
      if (regex.test(camelCaseValue)) {
        let tempHistory = [...employmentHistory];
        tempHistory[index][field] = camelCaseValue;
        setEmploymentHistory([...tempHistory]);
      }
      if (camelCaseValue === "") {
        let tempHistory = [...employmentHistory];
        tempHistory[index][field] = camelCaseValue;
        setEmploymentHistory([...tempHistory]);
      }

      let errorDestr = { ...error };
      if (!value.trim()) {
        errorDestr.referenceContactPerson1Name = true;
      } else {
        errorDestr.referenceContactPerson1Name = false;
      }
      setError(errorDestr);
    }

    if (field === "referenceContactPerson1Contact" && value.length <= 10) {
      let tempHistory = [...employmentHistory];
      tempHistory[index][field] = camelCaseValue;
      setEmploymentHistory([...tempHistory]);

      let errorDestr = { ...error };
      if (value.length !== 10) {
        errorDestr.referenceContactPerson1Contact = true;
      } else {
        errorDestr.referenceContactPerson1Contact = false;
      }
      setError(errorDestr);
    }

    if (field === "referenceContactPerson2Name") {
      if (camelCaseValue === "") {
        let tempHistory = [...employmentHistory];
        tempHistory[index][field] = camelCaseValue;
        setEmploymentHistory([...tempHistory]);
      }
      if (regex.test(camelCaseValue)) {
        let tempHistory = [...employmentHistory];
        tempHistory[index][field] = camelCaseValue;
        setEmploymentHistory([...tempHistory]);
      }

      let errorDestr = { ...error };
      if (!value.trim()) {
        errorDestr.referenceContactPerson2Name = true;
      } else {
        errorDestr.referenceContactPerson2Name = false;
      }
      setError(errorDestr);
    }

    if (field === "referenceContactPerson2Contact" && value.length <= 10) {
      let tempHistory = [...employmentHistory];
      tempHistory[index][field] = camelCaseValue;
      setEmploymentHistory([...tempHistory]);

      let errorDestr = { ...error };
      if (value.length !== 10) {
        errorDestr.referenceContactPerson2Contact = true;
      } else {
        errorDestr.referenceContactPerson2Contact = false;
      }
      setError(errorDestr);
    }

    if (validateerror) {
      const validateChange = [...validateerror];

      if (
        field === "referenceContactPerson1Name" &&
        validateChange[17][index]
      ) {
        validateChange[17][index].status = false;
      }
      if (
        field === "referenceContactPerson1Contact" &&
        validateChange[18][index]
      ) {
        validateChange[18][index].status = false;
      }
      if (
        field === "referenceContactPerson2Name" &&
        validateChange[19][index]
      ) {
        validateChange[19][index].status = false;
      }
      if (
        field === "referenceContactPerson2Contact" &&
        validateChange[20][index]
      ) {
        validateChange[20][index].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  const handleDateChange = (e, index, field) => {
    let tempHistory = [...employmentHistory];

    let date = "";
    if (e) {
      let m = e.$d.getMonth() + 1;
      m = m < 10 ? `0${m}` : m;
      let d = ("0" + e.$D).slice(-2);
      date = e.$d.getFullYear() + "-" + m + "-" + d;

      tempHistory[index][field] = date;
      setEmploymentHistory([...tempHistory]);
    }
    if (validateerror) {
      const validateDate = [...validateerror];
      if (field === "doj" && validateDate[14][index]) {
        validateDate[14][index].status = false;
      }
      if (field === "dol" && validateDate[15][index]) {
        validateDate[15][index].status = false;
      }
      setvalidateerror(validateDate);
    }
  };

  const handleEditHistory = (index) => {
    let tempEditHistory = [...employmentHistory];
    tempEditHistory.forEach((emp, i) => {
      if (i === index) {
        emp.isEdit = true;
      } else {
        emp.isEdit = false;
      }
    });
    setEmploymentHistory([...tempEditHistory]);
  };

  const handleEditHistory2 = (index) => {
    let tempEditHistory = [...employmentHistory];
    tempEditHistory.forEach((emp, i) => {
      if (i === index) {
        emp.isEdit = false;
      } else {
        emp.isEdit = true;
      }
    });
    setEmploymentHistory([...tempEditHistory]);
  };

  const handleSubmit = () => {
    if (validatehandler()) {
      handleButtonClick("sectionB");
      employmentHistory.map((history) => {
        if (history._id) {
          NewJoineeAPI.updateEmploymenthistory(
            user.isAdmin ? id : history._id,
            history
          );
          return;
        } else {
          NewJoineeAPI.createEmploymentHistory(history);
          return;
        }
      });
      // After official save, clear only Section B draft (if any).
      if (!user.isAdmin) deleteDraft();
      changeTab(2);
    } else {
      scrollToSectionBError();
    }
  };

  const handleClearAll = () => {
    setEmploymentHistory(initialState);
  };

  return (
    <div>
      {!fresher ? (
        <div>
          <div className={`row ${user.isAdmin ? "" : "mt-5 pb-0 mb-0"}`}></div>
          <div className="">
            {employmentHistory.map((emp, index) => {
              return (
                <div className={`row ${user.isAdmin ? "" : "pb-0 mb-0"}`}>
                  <div className="row row-cols-3 d-flex align-items-start overflow-hidden px-0 py-4">
                    <div className="col-lg-1 col-sm-1 col-md-1">
                      <AddCircleIcon sx={{ color: "blue" }} />
                    </div>
                    <div className="col-lg-9 col-md-7 facilityInfo overflow-hidden col-sm-9">
                      <span>Employment History {`${index + 1}`}</span>
                    </div>
                    <div className="row row-cols-2 col-lg-2 d-flex align-items-center justify-content-lg-evenly justify-content-sm-around justify-content-md-evenly col-sm">
                      {!emp.isEdit ? (
                        <div
                          className="col-lg-1 col-sm-1 col-md-1"
                          onClick={() => handleEditHistory(index)}
                        >
                          <EditIcon sx={{ color: "blue", cursor: "pointer" }} />
                        </div>
                      ) : (
                        <div
                          className="col-lg-1 col-sm-1 col-md-1"
                          onClick={() => handleEditHistory2(index)}
                        >
                          <EditIcon sx={{ color: "blue", cursor: "pointer" }} />
                        </div>
                      )}
                      {employmentHistory.length > 1 ? (
                        <div
                          className="col-lg-1 col-sm-2 col-md-4"
                          onClick={() => handleDeleteHistory(index)}
                        >
                          <DeleteForeverIcon
                            sx={{ color: "red", cursor: "pointer" }}
                          />
                        </div>
                      ) : (
                        <div className="col-lg-1 col-sm-2 col-md-4"></div>
                      )}
                    </div>
                  </div>
                  <hr />
                  {emp.isEdit ? (
                    <div className="col-12 py-3">
                      <div className="">
                        <Box
                          component="form"
                          sx={{
                            "& > :not(style)": {
                              marginRight: 3,
                              marginBottom: 3,
                            },
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          <TextField
                            className=""
                            sx={{ width: "30ch" }}
                            onChange={(e) =>
                              handleEmpChange(e, index, "employerName")
                            }
                            error={
                              validateerror && validateerror[0][index]
                                ? validateerror[0][index].status
                                : ""
                            }
                            value={emp.employerName}
                            id="outlined-basic"
                            label="Name of Employer/Organisation"
                            variant="outlined"
                            helperText={
                              error.employerName ? "Invalid Name" : ""
                            }
                            required
                            disabled={
                              user.isAdmin &&
                              (newJoineeSectionBFlagButton === "pending" ||
                                newJoineeSectionBFlagButton === "submitted" ||
                                newJoineeSectionBFlagButton === "review done" ||
                                newJoineeSectionBFlagButton ===
                                  "resubmission required")
                            }
                          />
                          <TextField
                            className=""
                            sx={{ width: "30ch" }}
                            onChange={(e) =>
                              handleContactChange(e, index, "companyContact")
                            }
                            error={
                              validateerror && validateerror[1][index]
                                ? validateerror[1][index].status
                                : ""
                            }
                            value={emp.companyContact}
                            type="number"
                            id="outlined-basic"
                            label="Contact Number"
                            variant="outlined"
                            helperText={
                              error.companyContact ? "Invalid Number" : ""
                            }
                            required
                            disabled={
                              user.isAdmin &&
                              (newJoineeSectionBFlagButton === "pending" ||
                                newJoineeSectionBFlagButton === "submitted" ||
                                newJoineeSectionBFlagButton === "review done" ||
                                newJoineeSectionBFlagButton ===
                                  "resubmission required")
                            }
                          />
                          <TextField
                            onChange={(e) =>
                              handleChange(e, index, "department")
                            }
                            error={
                              validateerror && validateerror[2][index]
                                ? validateerror[2][index].status
                                : ""
                            }
                            value={emp.department}
                            sx={{ width: "30ch" }}
                            id="outlined-basic"
                            label="Department"
                            variant="outlined"
                            required
                            disabled={
                              user.isAdmin &&
                              (newJoineeSectionBFlagButton === "pending" ||
                                newJoineeSectionBFlagButton === "submitted" ||
                                newJoineeSectionBFlagButton === "review done" ||
                                newJoineeSectionBFlagButton ===
                                  "resubmission required")
                            }
                          />
                        </Box>
                      </div>
                      <div className="col-12">
                        <Box
                          component="form"
                          sx={{
                            "& > :not(style)": {
                              marginRight: 3,
                              marginBottom: 3,
                            },
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          <TextField
                            onChange={(e) =>
                              handleChange(e, index, "employeeCode")
                            }
                            error={
                              validateerror && validateerror[3][index]
                                ? validateerror[3][index].status
                                : ""
                            }
                            sx={{ width: "30ch" }}
                            value={emp.employeeCode}
                            id="outlined-basic"
                            label="Employee Code"
                            variant="outlined"
                            required
                            disabled={
                              user.isAdmin &&
                              (newJoineeSectionBFlagButton === "pending" ||
                                newJoineeSectionBFlagButton === "submitted" ||
                                newJoineeSectionBFlagButton === "review done" ||
                                newJoineeSectionBFlagButton ===
                                  "resubmission required")
                            }
                          />
                          <TextField
                            onChange={(e) =>
                              handleChange(e, index, "designation")
                            }
                            error={
                              validateerror && validateerror[4][index]
                                ? validateerror[4][index].status
                                : ""
                            }
                            value={emp.designation}
                            sx={{ width: "30ch" }}
                            id="outlined-basic"
                            label="Designation"
                            variant="outlined"
                            required
                            disabled={
                              user.isAdmin &&
                              (newJoineeSectionBFlagButton === "pending" ||
                                newJoineeSectionBFlagButton === "submitted" ||
                                newJoineeSectionBFlagButton === "review done" ||
                                newJoineeSectionBFlagButton ===
                                  "resubmission required")
                            }
                          />
                          <TextField
                            className=""
                            sx={{ width: "30ch" }}
                            onChange={(e) =>
                              handleRemunerationChange(e, index, "remuneration")
                            }
                            error={
                              validateerror && validateerror[5][index]
                                ? validateerror[5][index].status
                                : ""
                            }
                            value={emp.remuneration}
                            id="outlined-basic"
                            label="Remuneration(in Lakhs)"
                            variant="outlined"
                            type="number"
                            required
                            disabled={
                              user.isAdmin &&
                              (newJoineeSectionBFlagButton === "pending" ||
                                newJoineeSectionBFlagButton === "submitted" ||
                                newJoineeSectionBFlagButton === "review done" ||
                                newJoineeSectionBFlagButton ===
                                  "resubmission required")
                            }
                          />
                          <TextField
                            onChange={(e) =>
                              handleReportedToChange(e, index, "reportedTo")
                            }
                            error={
                              validateerror && validateerror[6][index]
                                ? validateerror[6][index].status
                                : ""
                            }
                            sx={{ width: "30ch" }}
                            value={emp.reportedTo}
                            id="outlined-basic"
                            label="Reported To "
                            variant="outlined"
                            required
                            disabled={
                              user.isAdmin &&
                              (newJoineeSectionBFlagButton === "pending" ||
                                newJoineeSectionBFlagButton === "submitted" ||
                                newJoineeSectionBFlagButton === "review done" ||
                                newJoineeSectionBFlagButton ===
                                  "resubmission required")
                            }
                          />
                          <TextField
                            onChange={(e) =>
                              handleReportedPersonDesignation(
                                e,
                                index,
                                "reportedPersonDesig"
                              )
                            }
                            error={
                              validateerror && validateerror[7][index]
                                ? validateerror[7][index].status
                                : ""
                            }
                            value={emp.reportedPersonDesig}
                            sx={{ width: "30ch" }}
                            id="outlined-basic"
                            label="Reported Person Designation"
                            variant="outlined"
                            required
                            disabled={
                              user.isAdmin &&
                              (newJoineeSectionBFlagButton === "pending" ||
                                newJoineeSectionBFlagButton === "submitted" ||
                                newJoineeSectionBFlagButton === "review done" ||
                                newJoineeSectionBFlagButton ===
                                  "resubmission required")
                            }
                          />
                        </Box>
                      </div>
                      <div className="col-12 mb-4">
                        <Box
                          component="form"
                          sx={{
                            "& > :not(style)": { marginRight: 3 },
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          <TextField
                            select
                            sx={{ width: "30ch" }}
                            label="Nature of Bussiness"
                            value={emp.natureOfBusiness}
                            error={
                              validateerror && validateerror[8][index]
                                ? validateerror[8][index].status
                                : ""
                            }
                            onChange={(e) =>
                              handleChange(e, index, "natureOfBusiness")
                            }
                            required
                            disabled={
                              user.isAdmin &&
                              (newJoineeSectionBFlagButton === "pending" ||
                                newJoineeSectionBFlagButton === "submitted" ||
                                newJoineeSectionBFlagButton === "review done" ||
                                newJoineeSectionBFlagButton ===
                                  "resubmission required")
                            }
                          >
                            <MenuItem value={"Service Industry"}>
                              Service Industry
                            </MenuItem>
                            <MenuItem value={"It"}>IT</MenuItem>
                            <MenuItem value={"Manufacturing"}>
                              Manufacturing
                            </MenuItem>
                            <MenuItem value={"Cooperative"}>
                              Cooperative
                            </MenuItem>
                            <MenuItem value={"Marketing"}>Marketing</MenuItem>
                            <MenuItem value={"Public-Sector"}>
                              Public sector
                            </MenuItem>
                            <MenuItem value={"Banking"}>Banking</MenuItem>
                          </TextField>

                          <TextField
                            select
                            sx={{ width: "30ch" }}
                            label="Type of Employement"
                            value={emp.typeOfEmployment}
                            error={
                              validateerror && validateerror[9][index]
                                ? validateerror[9][index].status
                                : ""
                            }
                            onChange={(e) =>
                              handleChange(e, index, "typeOfEmployment")
                            }
                            required
                            disabled={
                              user.isAdmin &&
                              (newJoineeSectionBFlagButton === "pending" ||
                                newJoineeSectionBFlagButton === "submitted" ||
                                newJoineeSectionBFlagButton === "review done" ||
                                newJoineeSectionBFlagButton ===
                                  "resubmission required")
                            }
                          >
                            <MenuItem value={"Regular"}>Regular</MenuItem>
                            <MenuItem value={"Contract"}>Contract</MenuItem>
                            <MenuItem value={"Adhoc"}>Adhoc</MenuItem>
                            <MenuItem value={"Trainee "}>Trainee</MenuItem>
                          </TextField>
                        </Box>
                      </div>
                      <div className="col-12 mb-4">
                        <div>
                          <h5>
                            <span>Address of Employer</span>
                          </h5>
                        </div>
                        <div className="col-12">
                          <Box
                            component="form"
                            sx={{
                              "& > :not(style)": {
                                marginRight: 3,
                                width: "30ch",
                                marginBottom: 2,
                              },
                            }}
                            noValidate
                            autoComplete="off"
                          >
                            <TextField
                              onChange={(e) =>
                                handleAddressChange(e, index, "addressLine1")
                              }
                              error={
                                validateerror && validateerror[10][index]
                                  ? validateerror[10][index].status
                                  : ""
                              }
                              value={emp.addressLine1}
                              id="outlined-basic"
                              label="Address Line 1"
                              variant="outlined"
                              required
                              disabled={
                                user.isAdmin &&
                                (newJoineeSectionBFlagButton === "pending" ||
                                  newJoineeSectionBFlagButton === "submitted" ||
                                  newJoineeSectionBFlagButton ===
                                    "review done" ||
                                  newJoineeSectionBFlagButton ===
                                    "resubmission required")
                              }
                            />
                            <TextField
                              onChange={(e) =>
                                handleAddressChange(e, index, "addressLine2")
                              }
                              error={
                                validateerror && validateerror[11][index]
                                  ? validateerror[11][index].status
                                  : ""
                              }
                              value={emp.addressLine2}
                              id="outlined-basic"
                              label="Address Line 2"
                              variant="outlined"
                              required
                              disabled={
                                user.isAdmin &&
                                (newJoineeSectionBFlagButton === "pending" ||
                                  newJoineeSectionBFlagButton === "submitted" ||
                                  newJoineeSectionBFlagButton ===
                                    "review done" ||
                                  newJoineeSectionBFlagButton ===
                                    "resubmission required")
                              }
                            />
                            <TextField
                              onChange={(e) =>
                                handleCityChange(e, index, "city")
                              }
                              error={
                                validateerror && validateerror[12][index]
                                  ? validateerror[12][index].status
                                  : ""
                              }
                              value={emp.city}
                              id="outlined-basic"
                              label="City"
                              variant="outlined"
                              required
                              disabled={
                                user.isAdmin &&
                                (newJoineeSectionBFlagButton === "pending" ||
                                  newJoineeSectionBFlagButton === "submitted" ||
                                  newJoineeSectionBFlagButton ===
                                    "review done" ||
                                  newJoineeSectionBFlagButton ===
                                    "resubmission required")
                              }
                            />
                            <TextField
                              onChange={(e) =>
                                handleCityChange(e, index, "state")
                              }
                              error={
                                validateerror && validateerror[13][index]
                                  ? validateerror[13][index].status
                                  : ""
                              }
                              value={emp.state}
                              id="outlined-basic"
                              label="State"
                              variant="outlined"
                              required
                              disabled={
                                user.isAdmin &&
                                (newJoineeSectionBFlagButton === "pending" ||
                                  newJoineeSectionBFlagButton === "submitted" ||
                                  newJoineeSectionBFlagButton ===
                                    "review done" ||
                                  newJoineeSectionBFlagButton ===
                                    "resubmission required")
                              }
                            />
                          </Box>
                          <Box>
                            <Grid
                              container
                              spacing={3}
                              sx={{ marginBottom: "2%" }}
                            >
                              <Grid
                                item
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DatePicker
                                    label="Date of Joining *"
                                    value={emp.doj ? dayjs(emp.doj) : null}
                                    onChange={(date) =>
                                      handleDateChange(date, index, "doj")
                                    }
                                    disableFuture
                                    format="DD/MM/YYYY"
                                    renderInput={(params) => (
                                      <TextField {...params} />
                                    )}
                                    required
                                    disabled={
                                      user.isAdmin &&
                                      (newJoineeSectionBFlagButton ===
                                        "pending" ||
                                        newJoineeSectionBFlagButton ===
                                          "submitted" ||
                                        newJoineeSectionBFlagButton ===
                                          "review done" ||
                                        newJoineeSectionBFlagButton ===
                                          "resubmission required")
                                    }
                                  />
                                </LocalizationProvider>
                                <FormLabel
                                  style={{
                                    display:
                                      validateerror &&
                                      validateerror[14][index] &&
                                      validateerror[14][index].status
                                        ? ""
                                        : "none",
                                  }}
                                  sx={{ color: "red" }}
                                >
                                  (please select date)
                                </FormLabel>
                              </Grid>
                              <Grid
                                item
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DatePicker
                                    label="Date of Leaving *"
                                    value={emp.dol ? dayjs(emp.dol) : null}
                                    onChange={(date) =>
                                      handleDateChange(date, index, "dol")
                                    }
                                    minDate={emp.doj ? dayjs(emp.doj) : null}
                                    format="DD/MM/YYYY"
                                    renderInput={(params) => (
                                      <TextField {...params} />
                                    )}
                                    required
                                    disabled={
                                      user.isAdmin &&
                                      (newJoineeSectionBFlagButton ===
                                        "pending" ||
                                        newJoineeSectionBFlagButton ===
                                          "submitted" ||
                                        newJoineeSectionBFlagButton ===
                                          "review done" ||
                                        newJoineeSectionBFlagButton ===
                                          "resubmission required")
                                    }
                                  />
                                </LocalizationProvider>
                                <FormLabel
                                  style={{
                                    display:
                                      validateerror &&
                                      validateerror[15][index] &&
                                      validateerror[15][index].status
                                        ? ""
                                        : "none",
                                  }}
                                  sx={{ color: "red" }}
                                >
                                  (please select date)
                                </FormLabel>
                              </Grid>
                            </Grid>
                          </Box>
                        </div>
                      </div>
                      <div className="col-12 mb-4">
                        <div className="col-8 mb-4">
                          <div>
                            <h5>
                              <span>Reason for leaving</span>
                            </h5>
                          </div>
                          <TextField
                            fullWidth
                            id="outlined-multiline-static"
                            label="Write here"
                            multiline
                            rows={4}
                            value={emp.reasonForLeaving}
                            onChange={(e) =>
                              handleReasonForLeaving(
                                e,
                                index,
                                "reasonForLeaving"
                              )
                            }
                            error={
                              validateerror && validateerror[16][index]
                                ? validateerror[16][index].status
                                : ""
                            }
                            required
                            disabled={
                              user.isAdmin &&
                              (newJoineeSectionBFlagButton === "pending" ||
                                newJoineeSectionBFlagButton === "submitted" ||
                                newJoineeSectionBFlagButton === "review done" ||
                                newJoineeSectionBFlagButton ===
                                  "resubmission required")
                            }
                          />
                        </div>
                      </div>
                      <div className="col-12 mb-2">
                        <div className="mb-2">
                          <h5>
                            <span>Reference Contact Person</span>
                          </h5>
                        </div>
                        <div className="col-12">
                          <Box
                            component="form"
                            sx={{
                              "& > :not(style)": {
                                marginRight: 3,
                                width: "30ch",
                                marginBottom: 2,
                              },
                            }}
                            noValidate
                            autoComplete="off"
                          >
                            <TextField
                              onChange={(e) =>
                                handleReferenceChange(
                                  e,
                                  index,
                                  "referenceContactPerson1Name"
                                )
                              }
                              error={
                                validateerror && validateerror[17][index]
                                  ? validateerror[17][index].status
                                  : ""
                              }
                              value={emp.referenceContactPerson1Name}
                              id="outlined-basic"
                              label="Name"
                              variant="outlined"
                              helperText={
                                error.referenceContactPerson1Name
                                  ? "Invalid Name"
                                  : ""
                              }
                              required
                              disabled={
                                user.isAdmin &&
                                (newJoineeSectionBFlagButton === "pending" ||
                                  newJoineeSectionBFlagButton === "submitted" ||
                                  newJoineeSectionBFlagButton ===
                                    "review done" ||
                                  newJoineeSectionBFlagButton ===
                                    "resubmission required")
                              }
                            />
                            <TextField
                              type="number"
                              onChange={(e) =>
                                handleReferenceChange(
                                  e,
                                  index,
                                  "referenceContactPerson1Contact"
                                )
                              }
                              error={
                                validateerror && validateerror[18][index]
                                  ? validateerror[18][index].status
                                  : ""
                              }
                              value={emp.referenceContactPerson1Contact}
                              required
                              id="outlined-basic"
                              label="Contact Number"
                              variant="outlined"
                              inputProps={{ className: "number-input" }}
                              helperText={
                                error.referenceContactPerson1Contact
                                  ? "Invalid Contact"
                                  : ""
                              }
                              disabled={
                                user.isAdmin &&
                                (newJoineeSectionBFlagButton === "pending" ||
                                  newJoineeSectionBFlagButton === "submitted" ||
                                  newJoineeSectionBFlagButton ===
                                    "review done" ||
                                  newJoineeSectionBFlagButton ===
                                    "resubmission required")
                              }
                            />
                          </Box>
                          <Box
                            component="form"
                            sx={{
                              "& > :not(style)": {
                                marginRight: 3,
                                width: "30ch",
                              },
                            }}
                            noValidate
                            autoComplete="off"
                          >
                            <TextField
                              onChange={(e) =>
                                handleReferenceChange(
                                  e,
                                  index,
                                  "referenceContactPerson2Name"
                                )
                              }
                              error={
                                validateerror && validateerror[19][index]
                                  ? validateerror[19][index].status
                                  : ""
                              }
                              value={emp.referenceContactPerson2Name}
                              id="outlined-basic"
                              label="Name"
                              required
                              variant="outlined"
                              helperText={
                                error.referenceContactPerson2Name
                                  ? "Invalid Name"
                                  : ""
                              }
                              disabled={
                                user.isAdmin &&
                                (newJoineeSectionBFlagButton === "pending" ||
                                  newJoineeSectionBFlagButton === "submitted" ||
                                  newJoineeSectionBFlagButton ===
                                    "review done" ||
                                  newJoineeSectionBFlagButton ===
                                    "resubmission required")
                              }
                            />
                            <TextField
                              type="number"
                              onChange={(e) =>
                                handleReferenceChange(
                                  e,
                                  index,
                                  "referenceContactPerson2Contact"
                                )
                              }
                              error={
                                validateerror && validateerror[20][index]
                                  ? validateerror[20][index].status
                                  : ""
                              }
                              value={emp.referenceContactPerson2Contact}
                              id="outlined-basic"
                              label="Contact Number"
                              variant="outlined"
                              inputProps={{ className: "number-input" }}
                              helperText={
                                error.referenceContactPerson2Contact
                                  ? "Invalid Contact"
                                  : ""
                              }
                              required
                              disabled={
                                user.isAdmin &&
                                (newJoineeSectionBFlagButton === "pending" ||
                                  newJoineeSectionBFlagButton === "submitted" ||
                                  newJoineeSectionBFlagButton ===
                                    "review done" ||
                                  newJoineeSectionBFlagButton ===
                                    "resubmission required")
                              }
                            />
                          </Box>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="col-12 ms-2 mb-4 border-bottom border-2"></div>
                </div>
              );
            })}
            <div className="col-12 mb-5">
              <button
                type="button"
                onClick={() => handleAddHistroy()}
                className="btn btn-outline-primary"
                disabled={
                  user.isAdmin &&
                  (newJoineeSectionBFlagButton === "pending" ||
                    newJoineeSectionBFlagButton === "submitted" ||
                    newJoineeSectionBFlagButton === "review done" ||
                    newJoineeSectionBFlagButton === "resubmission required")
                }
              >
                <span style={{ fontSize: "" }}>+ Add Employment</span>
              </button>
            </div>
            {newJoineeSectionBFlagButton === "review done" ||
            ((newJoineeSectionBFlagButton === "pending" ||
              newJoineeSectionBFlagButton === "submitted" ||
              newJoineeSectionBFlagButton === "resubmission required") &&
              user.isAdmin) ? (
              ""
            ) : (
              <div className="col-12 d-flex align-items-center">
                <div className="d-flex align-items-center">
                  {!user.isAdmin && (
                    <button
                      type="button"
                      onClick={() => handleSaveDraft()}
                      className="btn btn-outline-primary btn-lg px-5 me-4"
                      disabled={draftSaving}
                    >
                      Save Draft
                    </button>
                  )}
                  <button
                    type="button"
                    onClick={() => handleSubmit()}
                    className="btn btn-primary btn-lg px-5 me-4"
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    onClick={() => handleClearAll()}
                    className="btn btn-outline-primary btn-lg px-5"
                  >
                    Clear All
                  </button>
                </div>

                {!user.isAdmin ? (
                  <DraftSavedAt className="ms-auto" date={lastDraftedAt} />
                ) : null}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          style={{ height: "70vh" }}
          className="d-flex justify-content-center align-items-center text-primary"
        >
          <h4>Since you are a fresher please skip this section !</h4>
        </div>
      )}
    </div>
  );
}

export default SectionB;
